import {
  apiBaseUrl
} from 'yxt-biz-pc/packages/api';

// 项目培训模型
export const getTrainingModel = (modelId, data) => {
  return apiBaseUrl.post(`/sptalent/client/training/model/${modelId}`, data);
};
